
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence, browserSessionPersistence } from "firebase/auth";
import { getAnalytics, isSupported as isAnalyticsSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};


//console.log("FIREBASE projectId =", firebaseConfig.projectId);

// const firebaseConfig = {
//   apiKey: "AIzaSyBGepsg2fzTUyjwQxU4dl2UMnOdq-r8VJ4",
//   authDomain: "koreanhome-f1d2e.firebaseapp.com",
//   projectId: "koreanhome-f1d2e",
//   storageBucket: "koreanhome-f1d2e.appspot.com",
//   messagingSenderId: "448229962091",
//   appId: "1:448229962091:web:55724f243c263b0a721c2e",
//   measurementId: "G-D26WFL1JD1"
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// 모바일/인앱 환경에서 세션 유지가 끊기는 문제를 줄이기 위해 persistence 설정
try {
  if (typeof window !== "undefined") {
    setPersistence(auth, browserLocalPersistence)
      .catch(() => setPersistence(auth, browserSessionPersistence));
  }
} catch (_) {}
export const db = getFirestore(app);
// IndexedDB가 막힌 환경에서는 analytics 초기화를 건너뛴다.
export const analyticsPromise = isAnalyticsSupported().then((supported) => {
  if (!supported) return null;
  return getAnalytics(app);
}).catch(() => null);





